export default __webpack_public_path__ + "static/media/ProfilePic.79e7bc63.png";